import React from "react";
import { useNavigate } from "react-router";
import PropTypes from "prop-types";
import "./Menu.css";
import { LogOut, UserRound } from "lucide-react";

const Menu = ({ showmenu }) => {
  const navigate = useNavigate();

  const handleProfileClick = () => {
    showmenu?.(false); // Optional chaining just in case
    navigate("/Profile");
  };

  const handleLogoutClick = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div className="menumodal_content">
      <div className="menu_drop" />
      <div className="menu_detail" onClick={handleProfileClick}>
        <UserRound style={{ cursor: "pointer" }} /> <span>Profile</span>
      </div>
      <div className="menu_detail" onClick={handleLogoutClick}>
        <LogOut style={{ cursor: "pointer" }} /> <span>Logout</span>
      </div>
    </div>
  );
};

Menu.propTypes = {
  showmenu: PropTypes.func.isRequired,
};

export default Menu;
